import React from 'react'
import { observer } from 'mobx-react'
import * as Displays from 'support/displays'
import { EconomyCard } from 'ui/cards'
import { EconomyCardText } from 'ui/elements'
import { useValue } from '@morningtrain/react-resources'
import AdjustScheduleButton from 'widgets/smartviews/partials/AdjustScheduleButton'
import ScheduleDaySummarySmartview from 'widgets/smartviews/shifts/ScheduleDaySummarySmartview'
import { MountSmartviewWithModelOnPipe, MountSmartviewWithModelOnClick } from '@morningtrain/react-smartviews'
import { CallbackOnPipe, Pipeline, TriggerPipelineOnClick } from '@morningtrain/react-helpers'
import useActiveScheduleWeekday from 'support/hooks/use-active-schedule-weekday'
import * as Icons from 'ui/icons'

function ScheduleDayOverviewCard (props) {
  const scheduleId = useValue('schedule_id')
  const weekDay = useValue('weekDay')

  const [activeScheduleWeekday, setActiveScheduleWeekday] = useActiveScheduleWeekday()

  return (
    <Pipeline>
      <CallbackOnPipe callback={() => { setActiveScheduleWeekday(weekDay) }} />
      <MountSmartviewWithModelOnPipe model={props.scheduleModel} smartview={<ScheduleDaySummarySmartview />} />
      <TriggerPipelineOnClick>
        <div>
          <EconomyCard>
            <EconomyCardText title='Forecast'>
              <Displays.Currency name='forecast' decimals={0} />
            </EconomyCardText>
            <EconomyCardText title='Lønprocent'>
              <Displays.Percentage name='salary_percentage' decimals={2} />
            </EconomyCardText>
            <EconomyCardText title='Låst budget'>
              <Displays.Currency name='forecast_locked_budget' decimals={0} />
            </EconomyCardText>

            <div className='flex group space-x-1'>
              <AdjustScheduleButton scheduleId={scheduleId} step={-500}>
                <button className='btn btn-small btn-full btn-lightgray'>
                  <Icons.Minus className='w-3' />
                </button>
              </AdjustScheduleButton>

              <AdjustScheduleButton scheduleId={scheduleId} step={500}>
                <button className='btn btn-small btn-full btn-lightgray'>
                  <Icons.Plus className='w-3' />
                </button>
              </AdjustScheduleButton>
            </div>
          </EconomyCard>
        </div>
      </TriggerPipelineOnClick>
    </Pipeline>
  )
}

export default observer(ScheduleDayOverviewCard)
